import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../../Global/slider.css";

const WorkshopSlider: React.FC<{
  images: {
    id: number;
    file_address: string;
    thumbnail_address: string;
  }[];
}> = ({ images }) => {
  return (
    <div className="slider-container">
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        speed={1000}
        pagination={true}
        spaceBetween={50}
        slidesPerView={1}
        loop={true}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index} style={{ zIndex: "10" }}>
            <img
              src={image.thumbnail_address}
              alt="picture1"
              className="w-full h-[269px] object-contain rounded-md mt-2"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default WorkshopSlider;
